// extracted by mini-css-extract-plugin
export default {"background_pic":"CustomerDupCheck_background_pic__uJNGi"};